import React from 'react';

const CardSkeleton = () => (
  <div className="bg-background-main border border-background-card rounded-lg p-4 w-[250px] h-[150px] shadow-sm flex justify-center items-center lg:w-[320px] lg:h-[230px]">
    <div className="space-y-2">
      {/* Image placeholder */}
      <div className="w-48 h-32 lg:w-72 lg:h-48 bg-background-card rounded animate-pulse" />
    </div>
  </div>
);
export default CardSkeleton;
